export default __webpack_public_path__ + "static/media/illustration.ae7276f0.svg";